module.exports = __webpack_public_path__ + "v294910/img/电子邮件确认.77fe1bc0.png";